import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill } from "@/components/Bits";
import { HeartHalf, Warning } from "@phosphor-icons/react";

export default function Health() {
  const [students, setStudents] = useState([]);
  useEffect(() => { api.get("/students").then(r => setStudents(r.data)); }, []);

  const withConditions = students.filter(s => (s.medical?.allergies?.length || 0) + (s.medical?.conditions?.length || 0) > 0);

  return (
    <div>
      <PageHeader eyebrow="Wellbeing" title="Health & medical" subtitle="Allergy alerts, medical notes, and emergency-ready records." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {withConditions.length === 0 && (
          <Panel><div className="text-center py-6 text-ink-soft">No active health alerts. 🌿</div></Panel>
        )}
        {withConditions.map(s => (
          <div key={s.student_id} className="bg-white rounded-3xl border border-border p-5" data-testid={`health-${s.student_id}`}>
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 rounded-xl bg-red-50 text-red-600 flex items-center justify-center"><HeartHalf weight="duotone" /></span>
              <div>
                <div className="font-heading font-bold">{s.name}</div>
                <div className="text-xs text-ink-soft">{s.age_group} · Blood: {s.blood_group}</div>
              </div>
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
              {(s.medical?.allergies || []).map(a => <Pill key={a} tone="danger"><Warning size={12} weight="bold" className="mr-1" /> {a}</Pill>)}
              {(s.medical?.conditions || []).map(c => <Pill key={c} tone="mustard">{c}</Pill>)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
